import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback } from 'react';
import Downshift from '@rexlabs/downshift';
import { SET_ITEMS, SET_MENU_STATE, ITEMS_LOADED, MENU_STATES } from './constants';
import { isEqual } from 'lodash';
export function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case SET_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: payload
      });

    case SET_MENU_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        menuState: payload
      });

    case ITEMS_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: payload,
        menuState: payload.length <= 0 ? MENU_STATES.NO_RESULTS_FOUND : MENU_STATES.HAS_ITEMS
      });

    default:
      return state;
  }
}
export var useStateReducerOverride = function useStateReducerOverride(_ref2) {
  var stateReducer = _ref2.stateReducer,
      disabled = _ref2.disabled,
      shouldBlurResetInput = _ref2.shouldBlurResetInput;
  return useCallback(function (state, changes) {
    var newChanges = changes;

    if (disabled) {
      return state;
    }

    switch (changes.type) {
      case Downshift.stateChangeTypes.keyDownEnter:
      case Downshift.stateChangeTypes.clickItem:
        if (changes.selectedItem.fixture) {
          // If the item attempting to be selected
          // is a fixture then we want to do nothing
          newChanges = {
            isOpen: false
          };
        } else {
          // If the user clicks on the item that is already
          // selected then remove the selected item
          if (isEqual(changes.selectedItem, state.selectedItem)) {
            newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
              selectedItem: null
            });
          }
        }

        break;

      case Downshift.stateChangeTypes.mouseUp:
      case Downshift.stateChangeTypes.blurInput:
        if (shouldBlurResetInput) {
          newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
            inputValue: ''
          });
        }

        break;
      // Don't reset entire select when pressing
      // escape and instead just close menu

      case Downshift.stateChangeTypes.keyDownEscape:
        newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
          inputValue: state.inputValue,
          selectedItem: state.selectedItem
        });
        break;
    }

    return stateReducer(state, newChanges);
  }, [disabled, stateReducer, shouldBlurResetInput]);
};